export const UPSELL_PAGE_DISMISSED_PROPERTY_KEY = 'jsm-cmdb-upsell-page-dismissed';
